import { Assets, Texture } from 'pixi.js'

// UI / 場景貼圖登錄 — 沿用 Unity Art（背景、轉輪框、底列、Logo）。
// 大圖維持單張、由 scripts/gen-atlas.mjs 壓成 WebP（public/images/ui/<name>.webp）。
const BASE = `${import.meta.env.BASE_URL}images/ui/`

const NAMES = [
  'frame',
  'bg_front',
  'board',
  'barBg',
  'logo',
  'wheel_disc',
  'wheel_frame',
  'wheel_hub',
  'mult_frame',
] as const
export type UiTextureName = (typeof NAMES)[number]

const textures: Partial<Record<UiTextureName, Texture>> = {}

export async function loadUiTextures(): Promise<void> {
  await Promise.all(
    NAMES.map(async (name) => {
      textures[name] = await Assets.load<Texture>(`${BASE}${name}.webp`)
    }),
  )
}

export function uiTexture(name: UiTextureName): Texture {
  return textures[name] ?? Texture.EMPTY
}
